var map = {
	"./App": 169,
	"./App.js": 169,
	"./NotFound": 126,
	"./NotFound.js": 126,
	"./PrivateRoute": 35,
	"./PrivateRoute.js": 35,
	"./Routes": 93,
	"./Routes.js": 93,
	"./SiteMigrated": 127,
	"./SiteMigrated.js": 127,
	"./Styleguide": 175,
	"./Styleguide.js": 175,
	"./checkout/AddressCombobox": 136,
	"./checkout/AddressCombobox.js": 136,
	"./checkout/AddressFields": 76,
	"./checkout/AddressFields.js": 76,
	"./checkout/CheckoutForm": 120,
	"./checkout/CheckoutForm.js": 120,
	"./checkout/EwaySecureFields": 121,
	"./checkout/EwaySecureFields.js": 121,
	"./checkout/FaqModal": 59,
	"./checkout/FaqModal.js": 59,
	"./checkout/FaqPage": 125,
	"./checkout/FaqPage.js": 125,
	"./checkout/OrderSummary": 132,
	"./checkout/OrderSummary.js": 132,
	"./checkout/OrderingPauseModal": 122,
	"./checkout/OrderingPauseModal.js": 122,
	"./checkout/PatientCheckout": 119,
	"./checkout/PatientCheckout.js": 119,
	"./checkout/Popup": 137,
	"./checkout/Popup.js": 137,
	"./checkout/TransactionSummary": 134,
	"./checkout/TransactionSummary.js": 134,
	"./components/input": 24,
	"./components/input.js": 24,
	"./components/notification": 61,
	"./components/notification.js": 61,
	"./components/tooltip": 62,
	"./components/tooltip.js": 62,
	"./data/favourites": 43,
	"./data/favourites.js": 43,
	"./data/gtm": 49,
	"./data/gtm.js": 49,
	"./data/mixture": 33,
	"./data/mixture.js": 33,
	"./data/order": 19,
	"./data/order.js": 19,
	"./data/orderHistory": 56,
	"./data/orderHistory.js": 56,
	"./data/patientList": 116,
	"./data/patientList.js": 116,
	"./data/patientOrder": 29,
	"./data/patientOrder.js": 29,
	"./data/transactionHistory": 78,
	"./data/transactionHistory.js": 78,
	"./helpers/Helpers": 101,
	"./helpers/Helpers.js": 101,
	"./helpers/LoadingComponent": 51,
	"./helpers/LoadingComponent.js": 51,
	"./layout/header": 92,
	"./layout/header.js": 92,
	"./mixtures/MaxProductsModal": 114,
	"./mixtures/MaxProductsModal.jsx": 114,
	"./mixtures/MixtureHeader": 111,
	"./mixtures/MixtureHeader.jsx": 111,
	"./mixtures/MixtureIndex": 109,
	"./mixtures/MixtureIndex.js": 109,
	"./mixtures/MixtureInstructions": 113,
	"./mixtures/MixtureInstructions.jsx": 113,
	"./mixtures/MixtureLineItems": 112,
	"./mixtures/MixtureLineItems.jsx": 112,
	"./mixtures/MixtureSummary": 110,
	"./mixtures/MixtureSummary.jsx": 110,
	"./patients/PaymentSuccess": 108,
	"./patients/PaymentSuccess.js": 108,
	"./practitioners/PractitionerIndex": 104,
	"./practitioners/PractitionerIndex.js": 104,
	"./practitioners/SetMarkupForm": 105,
	"./practitioners/SetMarkupForm.js": 105,
	"./practitioners/setRrpForm": 106,
	"./practitioners/setRrpForm.js": 106,
	"./practitionersNew/PatientDetail": 117,
	"./practitionersNew/PatientDetail.js": 117,
	"./practitionersNew/PatientEditModal": 118,
	"./practitionersNew/PatientEditModal.js": 118,
	"./practitionersNew/Patients": 115,
	"./practitionersNew/Patients.js": 115,
	"./practitionersNew/PrescriptionTable": 57,
	"./practitionersNew/PrescriptionTable.js": 57,
	"./practitionersNew/Prescriptions": 107,
	"./practitionersNew/Prescriptions.js": 107,
	"./products/Pagination": 95,
	"./products/Pagination.js": 95,
	"./products/ProductCard": 133,
	"./products/ProductCard.js": 133,
	"./products/ProductModal": 94,
	"./products/ProductModal.js": 94,
	"./products/ProductSearchForm": 130,
	"./products/ProductSearchForm.js": 130,
	"./products/ProductSearchIndex": 60,
	"./products/ProductSearchIndex.js": 60,
	"./sales_orders/CreateOrderForm": 50,
	"./sales_orders/CreateOrderForm.js": 50,
	"./sales_orders/DuplicateOrderForm": 103,
	"./sales_orders/DuplicateOrderForm.js": 103,
	"./sales_orders/MixtureLineItem": 100,
	"./sales_orders/MixtureLineItem.js": 100,
	"./sales_orders/OrderDetail": 102,
	"./sales_orders/OrderDetail.js": 102,
	"./sales_orders/OrderIndex": 97,
	"./sales_orders/OrderIndex.js": 97,
	"./sales_orders/OrderSummary": 96,
	"./sales_orders/OrderSummary.js": 96,
	"./sales_orders/PractitionerOrderDetail": 98,
	"./sales_orders/PractitionerOrderDetail.js": 98,
	"./services/apiClient": 7,
	"./services/apiClient.js": 7,
	"./services/authentication": 10,
	"./services/authentication.js": 10,
	"./sessions/login": 135,
	"./sessions/login.js": 135,
	"./surveys/OrderSurveyPopup": 99,
	"./surveys/OrderSurveyPopup.js": 99,
	"./transactions/TransactionTable": 124,
	"./transactions/TransactionTable.js": 124,
	"./transactions/Transactions": 123,
	"./transactions/Transactions.js": 123,
	"./transition/CLAUDE.md": 231,
	"./transition/TransitionGuideContext": 58,
	"./transition/TransitionGuideContext.js": 58,
	"./transition/TransitionGuideWidget": 131,
	"./transition/TransitionGuideWidget.js": 131,
	"./transition/steps/FirstPrescriptionStep": 129,
	"./transition/steps/FirstPrescriptionStep.js": 129,
	"./transition/steps/PatientReviewStep": 128,
	"./transition/steps/PatientReviewStep.js": 128,
	"./transition/steps/PricingSetupStep": 138,
	"./transition/steps/PricingSetupStep.js": 138,
	"./ui": 1,
	"./ui/": 1,
	"./ui/Alert": 83,
	"./ui/Alert.js": 83,
	"./ui/Badge": 82,
	"./ui/Badge.js": 82,
	"./ui/Button": 81,
	"./ui/Button.js": 81,
	"./ui/Card": 47,
	"./ui/Card.js": 47,
	"./ui/Form": 48,
	"./ui/Form.js": 48,
	"./ui/Modal": 89,
	"./ui/Modal.js": 89,
	"./ui/PageHeader": 88,
	"./ui/PageHeader.js": 88,
	"./ui/Pagination": 87,
	"./ui/Pagination.js": 87,
	"./ui/ProgressBar": 85,
	"./ui/ProgressBar.js": 85,
	"./ui/Spinner": 84,
	"./ui/Spinner.js": 84,
	"./ui/Table": 86,
	"./ui/Table.js": 86,
	"./ui/cn": 12,
	"./ui/cn.js": 12,
	"./ui/index": 1,
	"./ui/index.js": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 191;